import { forwardRef, useState, useEffect } from 'react';
import { cn } from '../../lib/utils';

interface FormMailProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
  validationError?: string;
  required?: boolean;
}

const FormMail = forwardRef<HTMLInputElement, FormMailProps>(
  ({ className, error, validationError, defaultValue, required, onChange, ...props }, ref) => {
    const [emailValue, setEmailValue] = useState(defaultValue?.toString() || '');
    const [emailError, setEmailError] = useState<string | null>(null);

    useEffect(() => {
      setEmailError(validationError || null);
    }, [validationError]);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      setEmailValue(e.target.value);
      onChange?.(e);
    };

    const inputClassName = cn(
      'mt-1 block w-full rounded-md shadow-sm sm:text-sm transition-colors duration-200',
      emailError || error
        ? 'border-red-300 focus:border-red-500 focus:ring-red-500'
        : 'border-gray-300 focus:border-primary-500 focus:ring-primary-500',
      className
    );

    return (
      <div>
        <input
          ref={ref}
          type="email"
          value={emailValue}
          onChange={handleInputChange}
          pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
          title="Digite um e-mail válido (exemplo@dominio.com)"
          className={inputClassName}
          required={required}
          {...props}
        />
        {emailError && <p className="mt-1 text-sm text-red-600">{emailError}</p>}
      </div>
    );
  }
);

FormMail.displayName = 'FormMail';

export { FormMail };
